<template>
    <div>
        <div id="hello-hello">

            <p style="display:inline;float: left;line-height: 22px;"><b>入库列表</b></p>

            <div style="display:inline-block">
                <el-radio-group v-model="statusSearch" @input="searchByStatus">
                    <el-radio-button label="0">待接收</el-radio-button>
                    <el-radio-button label="1">待审批</el-radio-button>
                    <el-radio-button label="2">已入库</el-radio-button>
                    <el-radio-button label="3">已退回</el-radio-button>
                    <el-radio-button label="-1">全部</el-radio-button>
                </el-radio-group>
            </div>

            <div style="display:inline-block;width: 300px;">
                <el-input placeholder="请输入产品名称" v-model="queryValue" class="input-with-select">
                    <el-button slot="append" icon="el-icon-search" @click="searchInStock"></el-button>
                </el-input>
            </div>

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="backClick()">退回</el-button>
            </p>
            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="operateClick(2)">审批</el-button>
                <span>-</span>
            </p>
            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="operateClick(1)">接收</el-button>
                <span>-</span>
            </p>

            <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                <el-button type="primary" round @click="openDrawer">新增入库</el-button>
                <span>-</span>
            </p>
        </div>

        <div style="margin-bottom: 20px;">
            <el-date-picker v-model="timeFrameValue" type="daterange" align="right" unlink-panels range-separator="至"
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="monthChange">
            </el-date-picker>

            <p style="display:inline;float: right;line-height: 40px;margin:0;">
                <el-button round @click="exportExcel">导出</el-button>
            </p>
        </div>

        <el-table :data="inStockList" style="width: 100%" @select="selectClick" @row-click="rowClick" ref="inStockTable"
            highlight-current-row>
            <el-table-column type="selection" width="45" label-class-name="DisabledSelection">
            </el-table-column>

            <el-table-column prop="inStockCode" label="入库编号" min-width="15%">
            </el-table-column>
            <el-table-column prop="orderCode" label="订单号" min-width="10%">
            </el-table-column>
            <el-table-column prop="productName" label="产品名称" min-width="23%">
                <template slot-scope="scope">
                    <div v-html="scope.row.productName"></div>
                </template>
            </el-table-column>

            <el-table-column prop="quantity" label="数量" min-width="8%">
            </el-table-column>
            <el-table-column prop="status" label="状态" min-width="8%">
            </el-table-column>

            <el-table-column prop="createdTime" label="申请日期" min-width="12%">
            </el-table-column>
            <el-table-column prop="applicant" label="申请人" min-width="8%">
            </el-table-column>

            <el-table-column prop="remark" label="备注" min-width="16%">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="success" round size="small">
                        查看
                    </el-button>
                    <el-button @click="deleteClick(scope.row)" type="danger" round size="small"
                        v-if="scope.row.status == '已入库' ? false : true">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount"
                layout="total, sizes,prev, pager, next" :total="total" @current-change="pageClick"
                :page-sizes="[8, 10, 15, 20]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

        <el-drawer title="入库详情" :visible.sync="drawerVisible" size="70%" style="text-align: left;">

            <div style="padding: 0 10px;">
                <p style="display:inline-block;width:80px;text-align: center;">申请日期</p>
                <el-date-picker v-model="form.createdTime" type="date" placeholder="选择日期" clear-icon="date-p" style="width:150px;" :disabled="productDisable">
                </el-date-picker>

                <p style="display:inline-block;width:80px;text-align: center;">订单号</p>
                <el-input v-model="form.orderCode" autocomplete="off" style="width:120px" :disabled="productDisable">
                </el-input>

                <p style="display:inline-block;width:80px;text-align: center;">备注</p>
                <el-input placeholder="请输入" v-model="form.remark" clearable style="display:inline-block;width:220px"
                    :disabled="productDisable"></el-input>

                <p style="display:inline-block;width:80px;text-align: center;">仓库</p>
                <el-select v-model="form.storeId" placeholder="请选择" style="width:120px">
                    <el-option v-for="item in form.storeList" :key="item.value" :label="item.storeName"
                        :value="item.id">
                    </el-option>
                </el-select>

                <p style="display:inline-block;width:80px;text-align: center;" v-if="saveBtnShow">添加产品</p>
                <el-select v-model="form.productName" filterable remote reserve-keyword placeholder="请输入关键字"
                    :remote-method="searchProduct" :loading="loading" v-if="saveBtnShow">
                    <el-option v-for="item in form.productList" :key="item.value" :label="item.productName"
                        :value="item.id">
                    </el-option>
                </el-select>

                <el-button type="primary" @click="addProduct" v-if="saveBtnShow">添加</el-button>
            </div>

            <div style="padding:10px;margin-bottom: 20px;">
                <el-table :data="inStockProdList" show-summary>
                    <el-table-column prop="productCode" label="产品编号" min-width="20%">
                    </el-table-column>
                    <el-table-column prop="productName" label="产品名称" min-width="30%">
                    </el-table-column>
                    <el-table-column prop="productWeight" label="产品重量" min-width="10%">
                    </el-table-column>

                    <el-table-column prop="specifications" label="规格" min-width="15%">
                    </el-table-column>

                    <el-table-column prop="quantity" label="数量" min-width="10%">
                        <template inline-template slot-scope="scope">
                            <el-input v-model="scope.row.quantity" size="mini" :disabled="productDisable">
                            </el-input>
                        </template>
                    </el-table-column>

                    <el-table-column prop="productRemark" label="备注" min-width="15%">
                        <template inline-template slot-scope="scope">
                            <el-input v-model="scope.row.productRemark" size="mini"
                                :disabled="productDisable"></el-input>
                        </template>
                    </el-table-column>

                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button @click="removeProduct(scope.row)" type="danger" round size="small"
                                :disabled="delBtnDisable">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div>
                <div style="margin-left: 40%;">
                    <el-button type="primary" round @click="addInStock" v-if="saveBtnShow">保存</el-button>

                    <el-button type="primary" round @click="editClick" v-if="!saveBtnShow && editBtnShow">编辑</el-button>
                </div>
            </div>

            <div>
                <p style="margin-left:20px;font-weight:bold">流转日志</p>
                <div style="padding:10px;">
                    <el-table :data="logList">
                        <el-table-column prop="createdTime" label="操作时间" min-width="25%">
                        </el-table-column>
                        <el-table-column prop="operationType" label="操作类型" min-width="25%">
                        </el-table-column>
                        <el-table-column prop="operator" label="操作人" min-width="25%">
                        </el-table-column>
                        <el-table-column prop="remark" label="操作说明" min-width="25%">
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </el-drawer>

        <el-dialog title="退回" :visible.sync="dialogVisible">
            <p style="display:inline-block;width:80px;text-align: center;">退回原因：</p>
            <el-input placeholder="请输入" v-model="backRemark" clearable
                style="display:inline-block;width:400px"></el-input>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmBack">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "InStock",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            userId: this.getUserId(),

            queryValue: '',
            inStockList: [],

            drawerVisible: false,
            dialogVisible: false,

            statusSearch: 0,
            form: {
                id: '',
                inStockCode: '自动生成',

                productList: [],
                productId: '',
                productName: '',

                storeId:'',
                storeList: [],

                createdTime: new Date(),
                status: 0,
                remark: '',
                orderCode:''
            },

            loading: false,

            inStockProdList: [],

            productDisable: false,
            delBtnDisable: false,

            logList: [],

            saveBtnShow: true,
            editBtnShow: false,

            pageIndex: 0,
            pageNum: 8,
            total: 0,
            pageCount: 0,

            backRemark: '',
            timeFrameValue: '',
            startTime: null,
            endTime: null
        }
    },
    methods: {
        searchInStock(query) {
            this.inStockList = []
            this.pageIndex = 0

            if (this.queryValue !== '') {

                this.loading = true

                setTimeout(() => {
                    this.loading = false

                    this.getAll(this.statusSearch)
                }, 200)
            } else {
                this.$message({
                    type: 'info',
                    message: '请输入搜索条件'
                })
            }
        },
        monthChange() {
            this.startTime = this.timeFrameValue[0]
            this.endTime = this.timeFrameValue[1]

            this.getAll(this.statusSearch)
        },
        exportExcel() {
            this.$axios({
                method: "post",
                url: "/shiro/in/stock/excel",
                data: {
                    status: this.statusSearch,
                    startTime: this.startTime,
                    endTime: this.endTime,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                },
                responseType: 'arraybuffer'
            }).then(result => {

                const data = result.data

                let objectUrl = result.config.url
                const blob = new Blob([data], {
                    type: 'application/vnd.ms-excel;charset=utf-8'
                })

                objectUrl = URL.createObjectURL(blob)
                const a = document.createElement("a")
                a.href = objectUrl

                a.download = "入库统计.xlsx"
                a.click()
                a.remove()
                URL.revokeObjectURL(objectUrl)
            })
        },
        addProduct() {
            // console.log('add')
            // console.log(this.form.productName)

            const index = this.form.productList.findIndex(obj => obj.id == this.form.productName)

            // console.log(this.form.productList[index])

            this.inStockProdList.push(this.form.productList[index])
        },
        removeProduct(row) {
            // console.log('remove')
            // console.log(row)

            const index = this.inStockProdList.findIndex(obj => obj.id == row.id)

            this.inStockProdList.splice(index, 1)
        },
        getAllBaseProduct(val) {
            this.$axios({
                method: "post",
                url: "/shiro/base/product/getAll",
                data: {
                    queryParam: val,
                    status: 1,
                    pageIndex: -1,
                    pageNum: -1,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.form.productList = data.data
            })
        },
        searchProduct(val) {
            if (val !== '') {

                this.loading = true

                setTimeout(() => {
                    this.loading = false

                    this.getAllBaseProduct(val)
                }, 200)

            } else {
                this.form.productList = []
            }
        },
        selectClick(selection, row) {

            this.$refs.inStockTable.clearSelection()
            this.$refs.inStockTable.toggleRowSelection(row)

            this.form.id = row.id
            this.form.status = row.status
        },
        rowClick(row) {
            //console.log(row)

            this.$refs.inStockTable.clearSelection()
            this.$refs.inStockTable.toggleRowSelection(row)

            this.form.id = row.id
            this.form.status = row.status
        },
        getInStockProduct(row) {

            this.$axios({
                method: "post",
                url: "/shiro/in/stock/getOne",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message(data.msg)
                    return
                }

                this.inStockProdList = data.data.inStockProductVOList
                for (let i in this.inStockProdList) {

                    this.inStockProdList[i].productRemark = this.inStockProdList[i].remark
                }

                this.logList = data.data.inOutLogsList
                for (let i in this.logList) {
                    this.logList[i].createdTime = this.$moment(this.logList[i].createdTime).format("YYYY-MM-DD HH:mm:ss")

                    if (this.logList[i].operationType == 0) {
                        this.logList[i].operationType = '申请'
                    } else if (this.logList[i].operationType == 1) {
                        this.logList[i].operationType = ' 接收'
                    } else if (this.logList[i].operationType == 2) {
                        this.logList[i].operationType = ' 审批'
                    } else {
                        this.logList[i].operationType = '退回'
                    }
                }

            })
        },
        handleClick(row) {
            // console.log(row)

            this.form.id = row.id

            this.form.inStockCode = row.inStockCode

            this.form.createdTime = row.createdTime

            this.form.status = null
            this.form.remark = row.remark

            this.form.orderCode=row.orderCode

            this.form.productName = ''

            this.drawerVisible = true
            this.productDisable = true
            this.delBtnDisable = true

            this.saveBtnShow = false
            this.editBtnShow = false

            if (row.status == '待接收') {
                this.editBtnShow = true
            }

            this.getInStockProduct(row)

            this.getAllBaseProduct('')
        },
        getAllStore() {
            this.$axios({
                method: "post",
                url: "/shiro/base/store/getAll",
                data: {
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.form.storeList = data.data

                if (this.form.storeList.length > 0) {
                    this.form.storeId = this.form.storeList[0].id
                }
            })
        },
        openDrawer() {

            this.form.id = ''
            this.form.inStockCode = '自动生成'

            this.form.applicant = ''
            this.form.productName = ''

            this.form.createdTime = new Date()

            this.form.status = 0
            this.form.remark = ''

            this.form.orderCode=''

            this.inStockProdList = []
            this.logList = []

            this.productDisable = false

            this.saveBtnShow = true

            this.drawerVisible = true

            this.getAllBaseProduct('')

            this.getAllStore()
        },
        operateClick(val) {

            if (this.form.id == '') {
                this.$message({
                    type: 'info',
                    message: '请选择入库单'
                })
                return
            }

            this.$confirm('确定执行此操作吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                if (val == 1) {
                    this.receiveClick()
                } else {
                    this.checkClick()
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                })
            })
        },
        receiveClick() {

            this.$axios({
                method: "post",
                url: "/shiro/in/stock/receive",
                data: {
                    id: this.form.id,
                    status: 1,
                    applicant: this.userId,
                    remark: '',
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message(data.msg)
                    return
                }

                this.drawerVisible = false

                this.getAll(this.statusSearch)
            })
        },
        checkClick() {

            this.$axios({
                method: "post",
                url: "/shiro/in/stock/check",
                data: {
                    id: this.form.id,
                    status: 2,
                    applicant: this.userId,
                    remark: '',
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message(data.msg)
                    return
                }

                this.drawerVisible = false

                this.getAll(this.statusSearch)
            })
        },
        backClick() {

            if (this.form.id == '') {
                this.$message({
                    type: 'info',
                    message: '请选择入库单'
                })
                return
            }

            if (this.form.status == '已入库' || this.form.status == '已退回') {
                this.$message({
                    type: 'info',
                    message: '当前状态不允许操作'
                })
                return
            }

            this.dialogVisible = true
        },
        confirmBack() {

            this.$axios({
                method: "post",
                url: "/shiro/in/stock/goBack",
                data: {
                    id: this.form.id,
                    status: 3,
                    applicant: this.userId,
                    remark: this.backRemark,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message(data.msg)
                    return
                }

                this.dialogVisible = false

                this.getAll(this.statusSearch)
            })
        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.removeInStock(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        addInStock() {

            const ispList = []

            for (let i in this.inStockProdList) {

                ispList.push({
                    productId: this.inStockProdList[i].id,
                    quantity: this.inStockProdList[i].quantity,
                    remark: this.inStockProdList[i].productRemark
                })
            }

            this.$axios({
                method: "post",
                url: "/shiro/in/stock/add",
                data: {
                    id: this.form.id,
                    inStockCode: this.form.inStockCode,

                    applicant: this.userId,
                    remark: this.form.remark,
                    orderCode:this.form.orderCode,

                    inStockProductList: ispList,

                    storeId: this.form.storeId,

                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message(data.msg)
                    return
                }

                this.drawerVisible = false

                this.getAll(this.statusSearch)
            })

        },
        editClick() {

            this.productDisable = false
            this.delBtnDisable = false

            this.saveBtnShow = true
        },
        printInStock(fang) {
            // console.log('fang')
            // console.log(fang)

            var content = document.getElementById("warehousing-list").innerHTML
            // console.log(content)

            var sprnstr = "<!--startprint" + fang + "-->"
            var eprnstr = "<!--endprint" + fang + "-->"

            var iframe = document.createElement("IFRAME")
            // console.log('iframe')
            // console.log(iframe)
            var doc = null;
            iframe.setAttribute('style', 'position:absolute;width:0;height:0;left:-500px;top:-500px;')

            document.body.appendChild(iframe)
            doc = iframe.contentWindow.document
            // console.log('doc')
            // console.log(doc)
            doc.write(content)
            doc.close()
            iframe.contentWindow.focus()

            iframe.contentWindow.addEventListener('load', function () {
                console.log('addEventListener')
                iframe.contentWindow.print()
                document.body.removeChild(iframe)
            })

        },
        searchByStatus(val) {
            this.pageIndex = 0

            this.getAll(val)
        },
        removeInStock(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/in/stock/remove",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.$message({
                    type: 'success',
                    message: data.msg
                })

                this.getAll(this.statusSearch)
            })
        },
        getAll(val) {

            this.$axios({
                method: "post",
                url: "/shiro/in/stock/getAll",
                data: {
                    status: val,
                    queryParam: this.queryValue,
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                this.form.id = ''

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    })
                    return
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.inStockList = data.data

                this.total = this.inStockList.length == 0 ? 0 : this.inStockList[0].total

                for (let i in this.inStockList) {
                    this.inStockList[i].createdTime = this.$moment(this.inStockList[i].createdTime).format("YYYY-MM-DD")

                    if (this.inStockList[i].status == 0) {
                        this.inStockList[i].status = '待接收'
                    } else if (this.inStockList[i].status == 1) {
                        this.inStockList[i].status = '待审批'
                    } else if (this.inStockList[i].status == 2) {
                        this.inStockList[i].status = '已入库'
                    } else {
                        this.inStockList[i].status = '已退回'
                    }
                }
            })
        },
        pageClick(currentPage) {
            this.inStockList = []

            this.pageIndex = (currentPage - 1) * this.pageNum

            this.getAll(this.statusSearch)
        },
        handleSizeChange(val) {
            this.pageNum = val

            this.getAll(this.statusSearch)
        },
    },
    mounted() {
        this.setDefaultPath('/inStock')

        this.getAll(this.statusSearch)
    },
    updated() {

    }
}
</script>

<style>
#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}

.el-pagination__total {
    color: green;
}

.date-p{
    display: none;
}
</style>